import React from 'react'
import StatusBadge from './StatusBadge'
import './index.scss'
import { SupplierDataType } from '../constants'
import kFormatter, { thousandsSeparator } from 'Utils/kFormatter'
import { Popover } from 'antd'

const SupplierRanking_Card = ({ data }: { data: SupplierDataType }) => {
  return (
    <div className="SupplierRanking-wrapper flex flex-col bg-white mb-4">
      <div className="SupplierRanking-header flex flex-row justify-between items-center">
        <div className="SupplierRanking-header-left flex">
          <div className="SupplierRanking-header-left-ranking"> #{data?.ranking}</div>
          <div className="SupplierRanking-header-left-title ml-2 font-semibold">
            {data?.supplier_name}
          </div>
        </div>
        <div className="SupplierRanking-header-right flex flex-col">
          <div className="SupplierRanking-header-right-title mb-1">Supplier Status</div>
          <div className="SupplierRanking-header-right-status">
            <StatusBadge status={data?.supplier_performance}></StatusBadge>
          </div>
        </div>
      </div>
      <div className="mt-4" style={{ height: 44 }}>
        <span className="SubCateSale-storage " style={{ fontWeight: 600 }}>
          Storage:{' '}
        </span>
        <span className="ml-1" style={{ wordBreak: 'break-all' }}>
          <span>
            {data?.storage?.length <= 1 ? (
              data?.storage?.map((item, index) => {
                return (
                  <span>
                    <span>
                      <span>{item}</span>
                    </span>
                  </span>
                )
              })
            ) : (
              <span>
                <span>
                  <span>{data?.storage[0]}</span>
                </span>
                <Popover
                  content={
                    <span className="overflow-scroll" style={{ maxHeight: 552 }}>
                      {data?.storage?.map((item, index) => {
                        if (index >= 1) return <div>{item}</div>
                      })}
                    </span>
                  }
                >
                  <span className="ml-1" style={{ color: '#1890FF' }}>{` + ${
                    data?.storage?.length - 1
                  } other promotions`}</span>
                </Popover>
              </span>
            )}
          </span>
        </span>
      </div>
      <div className="SupplierRanking-body flex justify-between">
        <div className="SupplierRanking-body-left">
          <div className="flex flex-row justify-between mt-2 hightlight-background">
            <div className="SupplierRanking-body-left-title ">Purchase Value</div>
            <div className="SupplierRanking-body-left-text">
              {kFormatter(data?.purchased_value)}
            </div>
          </div>
          <div className="flex flex-row justify-between mt-2">
            <div className="SupplierRanking-body-left-title">Revenue</div>
            <div className="SupplierRanking-body-left-text">
              {data?.revenue ? kFormatter(data?.revenue) : 0}
            </div>
          </div>
          <div className="flex flex-row justify-between mt-2 hightlight-background">
            <div className="SupplierRanking-body-left-title">Gross Profit</div>
            <div className="SupplierRanking-body-left-text">
              {thousandsSeparator(data?.gross_profit)}đ
            </div>
          </div>
          <div className="flex flex-row justify-between mt-2">
            <div className="SupplierRanking-body-left-title">% Gross Profit</div>
            <div className="SupplierRanking-body-left-text">
              {data?.ratio_gross_profit?.toFixed(0)}%
            </div>
          </div>
          <div className="flex flex-row justify-between mt-2 hightlight-background">
            <div className="SupplierRanking-body-left-title ">New Customer</div>
            <div className="SupplierRanking-body-left-text">
              {thousandsSeparator(data?.new_customer)}
            </div>
          </div>
          <div className="flex flex-row justify-between mt-2">
            <div className="SupplierRanking-body-left-title">Return Customer</div>
            <div className="SupplierRanking-body-left-text">
              {thousandsSeparator(data?.return_customer)}
            </div>
          </div>
          <div className="flex flex-row justify-between mt-2 hightlight-background">
            <div className="SupplierRanking-body-left-title">Avg Sales/</div>
            <div className="SupplierRanking-body-left-text">
              {thousandsSeparator(data?.revenue_per_customer)}
            </div>
          </div>
          <div className="flex flex-row justify-between hightlight-background">
            <div className="SupplierRanking-body-left-title">Customer</div>
          </div>
          <div className="flex flex-row justify-between mt-2">
            <div className="SupplierRanking-body-left-title">Inventory Days</div>
            <div className="SupplierRanking-body-left-text">
              {data?.inventory_days?.toFixed(0)} days
            </div>
          </div>
          <div className="flex flex-row justify-between mt-2 hightlight-background">
            <div className="SupplierRanking-body-left-title">Inventory Value</div>
            <div className="SupplierRanking-body-left-text">
              {kFormatter(data?.inventory_value)}
            </div>
          </div>
          <div className="flex flex-row justify-between mt-2">
            <div className="SupplierRanking-body-left-title">Credit Days</div>
            <div className="SupplierRanking-body-left-text">
              {data?.credit_days?.toFixed(0)} days
            </div>
          </div>
          <div className="flex flex-row justify-between mt-2 hightlight-background">
            <div className="SupplierRanking-body-left-title">Credit Value</div>
            <div className="SupplierRanking-body-left-text">{kFormatter(data?.credit_value)}</div>
          </div>
          <div className="flex flex-row justify-between mt-2">
            <div className="SupplierRanking-body-left-title">Account Payable</div>
            <div className="SupplierRanking-body-left-text">
              {kFormatter(data?.account_payable)}
            </div>
          </div>
          <div className="flex flex-row justify-between mt-2 hightlight-background">
            <div className="SupplierRanking-body-left-title">Purchase Order</div>
            <div className="SupplierRanking-body-left-text">
              {thousandsSeparator(data?.no_of_purchased_order)}
            </div>
          </div>
        </div>
        <div className="SupplierRanking-body-right">
          <div className="SupplierRanking-body-right-sku mt-2">SKU</div>
          <div className="SupplierRanking-body-right-group mt-2">
            <div className="flex flex-row justify-between mt-2 hightlight-background">
              <div className="SupplierRanking-body-right-title">Total</div>
              <div className="SupplierRanking-body-right-text">
                {thousandsSeparator(data?.total_of_sku)}
              </div>
            </div>
            <div className="flex flex-row justify-between mt-2">
              <div className="SupplierRanking-body-right-title">New</div>
              <div className="SupplierRanking-body-right-text">{thousandsSeparator(data?.new)}</div>
            </div>
            <div className="flex flex-row justify-between mt-2 hightlight-background">
              <div className="SupplierRanking-body-right-title">Red</div>
              <div className="SupplierRanking-body-right-text">{thousandsSeparator(data?.red)}</div>
            </div>
            <div className="flex flex-row justify-between mt-2 ">
              <div className="SupplierRanking-body-right-title">Green</div>
              <div className="SupplierRanking-body-right-text">
                {thousandsSeparator(data?.green)}
              </div>
            </div>
            <div className="flex flex-row justify-between mt-2 hightlight-background">
              <div className="SupplierRanking-body-right-title">Yellow</div>
              <div className="SupplierRanking-body-right-text">
                {thousandsSeparator(data?.yellow)}
              </div>
            </div>
            <div className="flex flex-row justify-between mt-2 ">
              <div className="SupplierRanking-body-right-title">Star</div>
              <div className="SupplierRanking-body-right-text">
                {thousandsSeparator(data?.star)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SupplierRanking_Card
